import { render, staticRenderFns } from "./PartnersJoin.vue?vue&type=template&id=5d580a1d&scoped=true&"
import script from "./PartnersJoin.vue?vue&type=script&lang=js&"
export * from "./PartnersJoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d580a1d",
  null
  
)

export default component.exports